<div class="w-100 d-flex mb-3">
  <h2 class="uppercase d-flex w-100 align-items-center"><i *ngIf="icon" class="material-icons-outlined">{{icon}}</i>{{ title }}</h2>
</div>
